import React from 'react';
import PropTypes from 'prop-types';
import ModalWrapper from './ModalWrapper';
import './style.scss';

const BlockUser = ({showBlockButton, userId, submitBlockTrigger, userName}) => (
    <ModalWrapper showBlockButton={showBlockButton}
        userId={userId}
        submitBlockTrigger={submitBlockTrigger}
        userName={userName}/>
);

BlockUser.propTypes = {
    userId: PropTypes.number,
    showBlockButton: PropTypes.bool,
    userName: PropTypes.string,
    submitBlockTrigger: PropTypes.func
};

BlockUser.defaultProps = {
    userId: 0,
    showBlockButton: false,
    userName: ''
};

export default BlockUser;


// WEBPACK FOOTER //
// ./src/components/block_user/index.js